if (!customElements.get('image-cards')) {
  class ImageCards extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.selectors = {
        sliderWrapper: '.image-cards__grid--slider',
        nextEl: '.swiper-btn-next',
        prevEl: '.swiper-btn-prev',
      };
      this.classes = {
        grid: 'image-cards__grid',
        swiper: 'swiper',
        swiperWrapper: 'swiper-wrapper',
      };

      this.sectionId = this.dataset.sectionId;
      this.section = this.closest(`.section-${this.sectionId}`);
      this.sliderWrapper = this.querySelector(this.selectors.sliderWrapper);

      this.enableSliderMobile = this.dataset.enableSliderMobile === 'true';
      this.columnsMobile = parseInt(this.dataset.columnsMobile, 10) || 1;
      this.sectionGap = parseInt(this.dataset.sectionGap, 10) || 8;

      this.sliderInstance = false;

      if (!this.enableSliderMobile || !this.sliderWrapper) return;

      const mql = window.matchMedia(FoxTheme.config.mediaQueryMobile);
      mql.onchange = this.init.bind(this);

      document.addEventListener('matchMobile', this.init.bind(this));
      document.addEventListener('unmatchMobile', this.init.bind(this));

      this.init();
    }

    init() {
      if (FoxTheme.config.mqlMobile) {
        this.initSlider();
      } else {
        this.destroySlider();
      }
    }

    initSlider() {
      if (typeof this.sliderInstance === 'object') return;

      const sliderOptions = {
        slidesPerView: this.columnsMobile,
        spaceBetween: this.sectionGap,
        navigation: {
          nextEl: this.section.querySelector(this.selectors.nextEl),
          prevEl: this.section.querySelector(this.selectors.prevEl),
        },
        pagination: false,
        threshold: 2,
      };

      this.classList.add(this.classes.swiper);
      this.sliderWrapper.classList.add(this.classes.swiperWrapper);

      this.sliderInstance = new window.FoxTheme.Carousel(this, sliderOptions);
      this.sliderInstance.init();
    }

    destroySlider() {
      this.classList.remove(this.classes.swiper);
      this.sliderWrapper.classList.remove(this.classes.swiperWrapper);

      if (typeof this.sliderInstance === 'object') {
        this.sliderInstance.slider.destroy();
        this.sliderInstance = false;
      }
    }
  }
  customElements.define('image-cards', ImageCards);
}
